import i18next from 'i18next';

export default function i18n(initialLocale, initialResources) {
  const initLanguage = initialLocale !== undefined ? initialLocale.substr(0, 2) : initialLocale;

  return i18next
    .use({
      type: 'backend',
      read: (locale, namespace, callback) => {
        const { debugLang, debugTranslation } = DEBUG_i18n();
        const language = debugLang(locale.substr(0, 2));
        return import(`./locales/messages_${language}.json`)
          .then(translation => {
            callback(null, debugTranslation(translation));
          })
          .catch(error => callback(error));
      },
    })
    .init({
      // Initial language
      lng: initLanguage,

      interpolation: {
        escapeValue: false, // not needed for react!!
      },
      // Fallback language
      fallbackLng: 'en',

      // Don't use a key separator (no support for nested translation objects)
      keySeparator: false,

      // Wait for translation data to be available before rendering a component
      react: {
        wait: true,
      },

      resources: initialResources,
    });
}

/**
 * Create an i18n object to be used by old restaurants utils functions like @wix/wixrest-utils
 *  */
export function i18nOldAdapter(googleLanguage, locale) {
  return {
    get: str => {
      const oldToNewKeyMap = {
        openrest_checkoutconfirmationview_subtotal: 'phoneordering_menu_orderhistory_subtotal_label',
        openrest_checkoutconfirmationview_tax: 'phoneordering_menu_orderhistory_taxes_label',
        openrest_checkoutconfirmationview_total: 'phoneordering_menu_orderhistory_total_label',
        openrest_checkoutconfirmationview_delivery: 'phoneordering_menu_orderhistory_ordertype_delivery',
        openrest_checkoutconfirmationview_takeout: 'phoneordering_menu_orderhistory_ordertype_pickup',
        openrest_checkoutconfirmationview_free: 'phoneordering_menu_dish_free_label',
        openrest_checkoutconfirmationview_kitchen_comment: 'phoneordering_checkout_success_comments_label',
        openrest_checkoutconfirmationview_postalcode: 'phoneordering_menu_orderhistory_postal_code',
        openrest_checkoutconfirmationview_apt: 'phoneordering_menu_orderhistory_apt_label',
        openrest_checkoutconfirmationview_floor: 'phoneordering_menu_orderhistory_floor_label',
        openrest_checkoutconfirmationview_entrance: 'phoneordering_menu_orderhistory_entrance_label',
        openrest_checkoutconfirmationview_delivery_instructions: 'phoneordering_menu_orderhistory_instructions_label',
        openrest_checkoutconfirmationview_on_arrival: 'phoneordering_menu_customerinfo_onarrival_label',
        openrest_checkoutconfirmationview_on_arrival_buzz: 'phoneordering_menu_customerinfo_onarrival_buzz',
        openrest_checkoutconfirmationview_on_arrival_phone: 'phoneordering_menu_customerinfo_onarrival_phone',
        openrest_checkoutconfirmationview_paying_with: 'phoneordering_menu_orderhistory_paymentmethod_label',
        openrest_checkoutconfirmationview_cash: 'phoneordering_checkout_cash_label',
        openrest_checkoutconfirmationview_without: 'phoneordering_checkout_confirmationview_without',
        deliverytime_asap: 'phoneordering_menu_orderhistory_deliverytime_asap',
        deliverytime_at_approx: 'phoneordering_menu_orderhistory_deliverytime_at_approx',
        deliverytime_asap_upto_after: 'phoneordering_menu_orderhistory_deliverytime_asap_upto_after',
        deliverytime_asap_upto: 'phoneordering_menu_orderhistory_deliverytime_asap_upto',
        deliverytime_asap_after: 'phoneordering_menu_orderhistory_deliverytime_asap_after',
        openrest_checkoutordersuccess_deliverytime: 'phoneordering_customerinfo_ordertype_delivery_time_label',
        openrest_checkoutconfirmationview_deliverytime: 'phoneordering_customerinfo_ordertype_delivery_time_label',
      };
      const newKey = oldToNewKeyMap[str];
      return newKey ? newKey : str;
    },
    getGoogleLanguage: () => googleLanguage || 'en',
    getLocale: () => locale || 'en_US',
  };
}

/**
 * function to help debug translations.
 * Allow to pass debugI18n query param with:
 *    nolang - to get the keys of the translation
 *    language:{language}(example language:he) - to get translation for a different language
 */
export function DEBUG_i18n() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const debugApp = urlParams.get('debugI18n');
  const identity = val => val;

  if (!debugApp) return { debugTranslation: identity, debugLang: identity };

  if (debugApp === 'nolang') {
    return {
      debugTranslation: translation => {
        // taking the translation keys and make them the value
        return Object.keys(translation.default).reduce((acc, val) => {
          acc[val] = val;
          return acc;
        }, {});
      },
      debugLang: identity,
    };
  } else if (debugApp.includes('language:')) {
    const debugLang = debugApp.split(':')[1];
    return { debugTranslation: identity, debugLang: () => debugLang };
  }
}
